import { parseElementFromString } from 'anodum';
import { connectedStore } from '../../store';
import getGlobal from '../selectors/global';

const extractGlobalContent = (globalId = null) => {
  if (!globalId) return null;

  const store = connectedStore.get();
  const state = store.getState();
  const global = getGlobal(state, globalId);
  if (!global || !global.html) return null;

  const globalFragment = parseElementFromString(global.html);

  if (!globalFragment) return null;

  return globalFragment;
};

export default extractGlobalContent;
